import { put, select } from "redux-saga/effects";
import { PayloadAction } from "@reduxjs/toolkit";
import { AuthUtils } from "@tecma/auth-utils";
import i18n from "@tecma/i18n";

import { applicationStateSelectors } from "store/slices/applicationState/selectors";
import { applicationStateActions } from "store/slices/applicationState/slice";
import { authStateSelectors } from "store/slices/auth/selectors";
import { EnvironmentState } from "store/slices/environment/slice";
import { environmentSelectors } from "store/slices/environment/selector";
import { User } from "types/auth";
import { EnabledTools } from "types/project";
import { getBackUrl } from "utils/detectUrl";

import { saveQuote } from "./application.api";

export function* saveQuoteSaga(
  action: PayloadAction<{
    spaceId: string;
    checkIn: string;
    checkOut: string;
  }>,
) {
  const { spaceId, checkIn, checkOut } = action.payload;
  const projectId: string = yield select(applicationStateSelectors.projectID);
  const loggedUser: User = yield select(authStateSelectors.userLogged);
  const queryParams = new URLSearchParams(window.location.search);
  const clientId = loggedUser?.client ?? queryParams.get("clientId");
  const environment: EnvironmentState = yield select(
    environmentSelectors.environment,
  );
  yield put(applicationStateActions.loadingRequired());
  if (clientId) {
    yield saveQuote(
      {
        projectId,
        spaceId,
        clientId,
        checkIn,
        checkOut,
        spaceType: "Room",
      },
      environment.REACT_APP_CLIENT_API_REST_URI,
    );
    const colivingConfiguration = localStorage.getItem(
      "COLIVING_configuration",
    );
    if (colivingConfiguration) {
      localStorage.removeItem("COLIVING_configuration");
    }

    if (queryParams.get("clientId")) {
      yield put(applicationStateActions.loadingStopRequired());
      yield put(applicationStateActions.showNewUserModal(true));
    } else {
      const myHome: EnabledTools = yield select(
        applicationStateSelectors.myHome,
      );
      AuthUtils.redirectToTool({
        redirectUrl: myHome?.url ?? "",
        projectId: projectId ?? "",
        locale: i18n.language,
      });
    }
  } else {
    localStorage.setItem(
      "COLIVING_configuration",
      JSON.stringify({
        [projectId]: {
          projectId,
          spaceId,
          checkIn,
          checkOut,
        },
      }),
    );
    const myAccount: EnabledTools = yield select(
      applicationStateSelectors.myAccount,
    );
    AuthUtils.authenticate({
      projectId,
      redirectUrl: getBackUrl(),
      platform: "COLIVING",
      locale: i18n.language,
      myAccountBaseUrl: myAccount?.url ?? "",
      isConfigurationComplete: true,
      redirectToSignUp: true,
    });
  }
}
